import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DiffIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Diff",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.9 26.5 28.4 24 16.9 4.5c-.3-.5-.9-.6-1.4-.4-.1.1-.3.2-.3.3L13.7 7 3.6 24l-1.5 2.5c-.2.5-.1 1.1.4 1.4.1.1.3.1.5.1h26c.6 0 1-.4 1-1 0-.2 0-.4-.1-.5m-15-17.6L23.7 24H5.9z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M30.71 29.28H1A1.14 1.14 0 1 1 1 27h27.73L15.21 3.57c-.32-.55-.13-1.25.42-1.56s1.25-.13 1.56.42l14.52 25.14c.2.35.2.79 0 1.14s-.58.57-.99.57Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.43 23.57H5.16c-.41 0-.79-.22-1-.58-.2-.36-.2-.8.02-1.15l7.8-12.94c.21-.35.61-.54.99-.55.4 0 .78.22.98.57l7.47 12.94c.2.35.2.79 0 1.14s-.58.57-.99.57M7.18 21.28h11.27l-5.51-9.55-5.75 9.55Z"
      })]
    })
  }));
};
DiffIcon.displayName = 'DiffIcon';